// API
import {
  IWHBreadcrumbModel,
  WHIconENUM,
  WHRouteZeroENUM,
  IWHBreadcrumbConfig,
} from '@workheld/workheld-shared-lib';

// APP
import { ROUTE_NAME } from 'src/app/w-h-content-page/w-h-content-page/w-h-content-page.component';

/**
 * Navigation group (first crumb) per first route segment.
 * Pages are only listed here to get a group crumb in front of their own crumbs;
 * their own labels are declared on the route via `data.breadcrumb`.
 */
const FLOW_BREADCRUMB_GROUPS: Record<string, string> = {
  // overview
  [WHRouteZeroENUM.HOME]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.PROJECT_OVERVIEW]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.WORK_OBJECT_REPORTS_OVERVIEW]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.WORK_OBJECT_MATERIALUSAGE_REPORT]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.WORK_OBJECT_COMPLETION_REPORT]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.WORK_OBJECT_EFFORT_REPORT]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.TIME_REPORT]: ROUTE_NAME.OVERVIEW,
  [WHRouteZeroENUM.DAILY_DASHBOARD]: ROUTE_NAME.OVERVIEW,
  '/equipmentreport': ROUTE_NAME.OVERVIEW,
  // work
  [WHRouteZeroENUM.PROJECTS]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.CASES]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.CASES_CATEGORY]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.STANDING_ORDER]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.MAINTENANCE_NOTIFICATIONS]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.ENTRIES_UNASSIGNED]: ROUTE_NAME.WORK,
  [WHRouteZeroENUM.TEAM_PLANNER]: ROUTE_NAME.WORK,
  // shift management
  [WHRouteZeroENUM.SHIFT_PLANNER]: ROUTE_NAME.SHIFT,
  [WHRouteZeroENUM.INFOSCREEN]: ROUTE_NAME.SHIFT,
  [WHRouteZeroENUM.SHIFT_GROUPS]: ROUTE_NAME.SHIFT,
  [WHRouteZeroENUM.SHIFT_DEFINITIONS]: ROUTE_NAME.SHIFT,
  [WHRouteZeroENUM.SHIFT_CALENDAR]: ROUTE_NAME.SHIFT,
  [WHRouteZeroENUM.SHIFT_BOOK]: ROUTE_NAME.SHIFT,
  // equipment
  [WHRouteZeroENUM.EQUIPMENTS]: ROUTE_NAME.EQUIPMENT,
  [WHRouteZeroENUM.EQUIPMENT_PLANNER]: ROUTE_NAME.EQUIPMENT,
  [WHRouteZeroENUM.MAINTENANCE_PLAN]: ROUTE_NAME.EQUIPMENT,
  // material
  [WHRouteZeroENUM.MATERIALS]: ROUTE_NAME.MATERIAL,
  [WHRouteZeroENUM.MATERIALINVENTORY]: ROUTE_NAME.MATERIAL,
  // master data
  [WHRouteZeroENUM.CUSTOMERS]: ROUTE_NAME.MASTERDATA,
  [WHRouteZeroENUM.CHECKLIST_DEFINITION]: ROUTE_NAME.MASTERDATA,
  [WHRouteZeroENUM.WORK_OBJECT_TEMPLATES]: ROUTE_NAME.MASTERDATA,
  [WHRouteZeroENUM.EXECUTION_GROUPS]: ROUTE_NAME.MASTERDATA,
  [WHRouteZeroENUM.TOOLS]: ROUTE_NAME.MASTERDATA,
  // human resources
  [WHRouteZeroENUM.HR_WORKERS]: ROUTE_NAME.HUMANRESOURCES,
  [WHRouteZeroENUM.ABSENCE_REQUESTS]: ROUTE_NAME.HUMANRESOURCES,
  [WHRouteZeroENUM.JOB_REQUIREMENTS]: ROUTE_NAME.HUMANRESOURCES,
  [WHRouteZeroENUM.QUALIFICATIONS]: ROUTE_NAME.HUMANRESOURCES,
  [WHRouteZeroENUM.SKILLS]: ROUTE_NAME.HUMANRESOURCES,
};

export const FLOW_BREADCRUMB_CONFIG: IWHBreadcrumbConfig = {
  getRootCrumbs: (routeCrumbs: IWHBreadcrumbModel[]): IWHBreadcrumbModel[] => {
    const first = routeCrumbs[0]?.urlSegmentPath;
    const group = first !== undefined ? FLOW_BREADCRUMB_GROUPS[first] : null;
    if (!group) {
      return [];
    }
    return [
      {
        enabled: true,
        nameI18nKey: group,
        routeUrl: WHRouteZeroENUM.STATUS_OVERVIEW,
        urlSegmentPath: first,
        icon: WHIconENUM.WorkheldIcon,
      },
    ];
  },
};
